import { render, staticRenderFns } from "./viewFranchiseClinicList.vue?vue&type=template&id=b32fab3c&"
import script from "./viewFranchiseClinicList.vue?vue&type=script&lang=js&"
export * from "./viewFranchiseClinicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports